export default __webpack_public_path__ + "static/media/img-slider-dlttaxi-1.4d4a8606.png";